//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            currentValue: this.value
        }
    },
    watch: {
        value (value, old) {
            if (value !== old) {
                this.currentValue = value
            }
        }
    },
    methods: {
        onFocus (e) {
            this.focus = true
            const height = e.target.offsetHeight
            // console.log(e.target)
            // this.$emit('changeBottom', height)
        },
        onBlur () {
            this.focus = false
            this.$emit('blur')
        },
        handleInput (e) {
            const { target: { value } } = e
            this.currentValue = value
            setTimeout(() => this.$emit('input', value))
        },
        onConfirm (e) {
            this.$emit('confirm', e)
        }
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        className: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        maxlength: {
            type: Number,
            default: 200
        }
    }
}
